const events = {
  all: 'Todo',
  categories: {
    ACCESS: 'Acceso',
    ALARM: 'Alarma',
    CONFIGURATION: 'Configuración',
    DETAILED_ACCESS: 'Acceso detallado',
    HARDWARE: 'Hardware',
    INTEGRATION: 'Integración',
    SYSTEM: 'Sistema',
    WARNING: 'Advertencia',
  },
  general: {
    add: 'Agregar',
    assign: 'Asignar',
    fetchError: 'Error al obtener datos',
  },
  selectors: {
    selector2: {
      security: 'Seguridad',
      lockdown: 'Bloqueo',
    },
    selector3: {
      user: 'Usuario',
    },
  },
  table: {
    object: 'Objeto',
    instigator: 'Instigador',
  },
};

export default events;
